// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const COMMON_PLACES_ABROAD = "Zahrani\u010die";
export const PAGE_SLUG = "strana";
